var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 2,
    fill: "#183433"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10304_29746)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0359 7.01443C21.1605 5.88971 22.9561 5.84472 24.1345 6.87946L24.2785 7.01443L24.9856 7.72153C26.1103 8.84624 26.1553 10.6418 25.1206 11.8202L24.9856 11.9642L13.7733 23.1765C13.6143 23.3355 13.422 23.4562 13.2113 23.5305L13.0499 23.5774L8.59502 24.6055C7.91223 24.763 7.29642 24.1916 7.37494 23.5181L7.39457 23.4051L8.42262 18.9501C8.47319 18.7309 8.57222 18.5267 8.71158 18.352L8.82355 18.2268L20.0359 7.01443ZM19.3287 10.55L10.3392 19.5396L9.70276 22.2973L12.4605 21.6609L21.45 12.6713L19.3287 10.55ZM22.8643 8.42864C22.5038 8.06816 21.9366 8.04043 21.5443 8.34545L21.4501 8.42864L20.7429 9.13581L22.8642 11.2571L23.5714 10.55C23.9318 10.1895 23.9596 9.62224 23.6546 9.22995L23.5714 9.13575L22.8643 8.42864Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10304_29746"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c27363195ac2d3f9025a13eb57b0ec2e.svg";
export { ForwardRef as ReactComponent };